var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 533,
    viewBox: "0 0 533 533",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9592 418.53C60.9592 418.53 26.1053 336.484 70.1854 274.48C114.266 212.476 87.3811 157.511 164.777 102.79C264.257 32.4554 360.21 101.851 388.823 148.901C417.437 195.951 514.624 171.933 486.38 305.811C464.469 409.663 480.818 414.219 480.818 414.219L60.9592 418.53Z",
    fill: "#F1EEFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9594 396.335C81.9594 396.335 20.1058 364.02 35.0096 291.357C49.9133 218.694 110.611 201.452 135.574 206.786C182.361 216.784 105.921 246.283 87.6615 195.651C64.751 132.121 146.439 84.0222 222.162 96.4699C270.828 104.47 294.319 127.767 337.58 142.405C380.686 156.991 398.765 137.455 381.591 126.133C365.288 115.385 306.098 132.921 326.421 156.955C354.249 189.863 421.313 138.876 473.29 195.651C525.267 252.425 480.145 323.801 440.186 329.753C400.227 335.705 417.747 278.348 480.145 323.802C542.542 369.256 463.725 418.532 463.725 418.532",
    stroke: "#C3C8FF",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M506.682 423.075H33.8625C31.3521 423.075 29.3182 421.04 29.3182 418.531C29.3182 416.02 31.3532 413.986 33.8625 413.986H511.226V418.531C511.226 421.04 509.191 423.075 506.682 423.075Z",
    fill: "#6876EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.777 423.075H33.8625C31.3521 423.075 29.3182 421.04 29.3182 418.531V413.986H208.322V418.531C208.322 421.04 206.287 423.075 203.777 423.075Z",
    fill: "#1C145E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M274.412 240.735C254.164 279.644 231.414 295.495 231.414 295.495L251.061 326.863L285.37 291.21L274.412 240.735Z",
    fill: "#1C145E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M324.615 231.448L274.412 240.735C271.232 335.719 270.04 413.974 270.04 413.974H360.153C360.153 413.974 362.768 268.525 348.272 236.791L324.615 231.448Z",
    fill: "#1C145E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M318.786 279.852L343.244 277.782",
    stroke: "#6876EB",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M307.559 259.438C307.559 259.438 323.083 365.374 309.576 408.237",
    stroke: "#6876EB",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M291.305 312.502C291.305 312.502 306.299 318.538 325.739 319.176C345.178 319.815 333.083 330.158 304.265 328.197",
    stroke: "#6876EB",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M295.169 227.586L307.559 260.504L324.615 231.448L313.374 213.077L295.169 227.586Z",
    fill: "#E9A394"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M307.559 260.504L330.688 254.118L324.615 231.448L307.559 260.504Z",
    fill: "#6876EB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M297.922 234.901L285.37 248.921L307.559 260.504L297.922 234.901Z",
    fill: "#6876EB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M251.061 326.863C251.061 326.863 258.392 311.576 242.651 291.886C233.923 280.967 229.901 262.125 229.901 262.125L216.787 264.12L228.796 326.864H251.061V326.863Z",
    fill: "#E9A394"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M214.106 242.452L208.737 247.332L215.915 253.668L193.437 253.286L192.956 260.998L216.786 264.12L229.901 262.125L214.106 242.452Z",
    fill: "#E9A394"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M218.034 254.464L196.468 245.568L195.076 249.399L213.076 256.964L218.034 254.464Z",
    fill: "#E9A394"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M348.273 236.791C348.273 236.791 377.244 253.286 386.392 315.073L352.781 323.183L348.273 236.791Z",
    fill: "#1C145E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M285.353 187.359L274.412 215.356L282.779 217.931L285.353 233.7L312.065 227.586L315.926 184.785L285.353 187.359Z",
    fill: "#E9A394"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M303.18 194.012H282.753L284.981 187.976L303.18 186.851V194.012Z",
    fill: "#E37A82"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M313.854 206.785C313.854 206.785 300.822 204.089 300.822 190.607C300.822 190.607 281.486 193.239 274.81 182.743C266.904 170.31 278.987 156.023 288.966 158.926C288.966 158.926 282.678 165.159 292.228 165.891C299.039 166.413 311.484 157.352 315.927 166.116C315.927 166.116 350.208 173.946 324.616 205.886L313.854 206.785Z",
    fill: "#16005C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M300.821 189.541C300.821 189.541 274.974 194.535 269.568 176C266.407 165.164 277.269 158.993 277.269 158.993",
    stroke: "#16005C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M289.884 214.464C295.272 214.464 299.641 210.096 299.641 204.707C299.641 199.318 295.272 194.95 289.884 194.95C284.495 194.95 280.127 199.318 280.127 204.707C280.127 210.096 284.495 214.464 289.884 214.464Z",
    stroke: "#16005C",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M299.116 201.55L313.013 202.311",
    stroke: "#16005C",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M330.688 209.242C330.688 215.285 322.592 220.183 316.549 220.183C310.506 220.183 308.805 215.284 308.805 209.242C308.805 203.2 313.705 198.3 319.747 198.3C325.789 198.3 330.688 203.2 330.688 209.242Z",
    fill: "#E9A394"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M382.381 316.04V366.496H357.222L355.128 322.616L382.381 316.04Z",
    fill: "#E9A394"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M272.453 304.634L273.509 269.477L257.212 320.473L272.453 304.634Z",
    fill: "#1C145C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M296.464 230.934L312.065 227.586L299.275 238.494L296.464 230.934Z",
    fill: "#E37A82"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M287.238 209.242C288.269 209.242 289.106 207.498 289.106 205.347C289.106 203.195 288.269 201.452 287.238 201.452C286.206 201.452 285.37 203.195 285.37 205.347C285.37 207.498 286.206 209.242 287.238 209.242Z",
    fill: "#16005C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M292.31 195.873C292.31 190.654 288.155 194.168 288.155 194.168L292.31 195.873Z",
    fill: "#16005C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M288.154 218.98L294.097 217.398C294.097 217.398 296.643 239.441 288.154 218.98Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M160.087 317.781C160.087 317.781 200.182 311.577 200.97 381.496C201.098 392.842 208.322 413.985 208.322 413.985H171.985L160.087 317.781Z",
    fill: "#5321D7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M118.162 311.577L93.9285 317.297L101.322 413.985H195.612C195.612 413.985 192.449 337.486 156.892 314.536L118.162 311.577Z",
    fill: "#6A3FDC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9285 317.297C68.951 322.994 74.798 342.165 79.6206 381.532C67.1537 391.657 79.1143 396.214 79.1143 396.214C65.4226 410.728 82.5031 413.985 82.5031 413.985H128.1C128.1 413.985 118.923 311.596 93.9285 317.297Z",
    fill: "#6A3FDC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M125.388 391.654L114.446 341.424",
    stroke: "#5321D7",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M82.502 413.985C82.502 413.985 90.2007 396.31 114.532 387.424C134.706 380.057 164.216 399.182 183.107 381.009L186.605 401.469L128.099 413.985H82.502Z",
    fill: "#E9A394"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M162.71 261.78L180.749 289.238L169.173 293.37L167.172 315.684L132.384 303.598L135.662 258.209L162.71 261.78Z",
    fill: "#E9A394"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M135.944 290.623L118.162 311.577L140.966 339.523L151.25 306.882L135.944 290.623Z",
    fill: "#E37A82"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M141.89 277.648L167.335 268.821L162.71 261.78L137.574 264.396L141.89 277.648Z",
    fill: "#E37A82"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M139.693 287.267C139.693 287.267 147.397 302.691 142.037 272.959C142.037 272.959 149.348 273.78 155.073 264.131C155.073 264.131 153.294 279.854 170.089 264.131C186.884 248.408 165.533 236.106 139.443 240.735C116.83 244.747 94.2013 257.523 127.275 300.838L139.693 287.267Z",
    fill: "#16005C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M135.574 293.399C133.838 295.727 130.857 297.838 127.757 298.29C121.557 299.193 115.502 294.299 114.599 288.099C113.696 281.899 116.828 278.68 123.027 277.777C126.512 277.27 130.547 278.303 133.573 280.406C134.488 281.546 135.574 293.399 135.574 293.399Z",
    fill: "#E9A394"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M160.115 284.829C161.044 284.577 161.33 282.656 160.755 280.537C160.18 278.418 158.962 276.905 158.033 277.157C157.105 277.409 156.818 279.33 157.393 281.449C157.968 283.568 159.187 285.081 160.115 284.829Z",
    fill: "#16005C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M153.063 275.603C153.063 275.603 152.159 270.504 156.892 272.959L153.063 275.603Z",
    fill: "#16005C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M115.315 312.434L119.443 307.692L117.928 304.178L127.274 300.839L154.085 314.322L155.072 324.616L150.535 323.182L143.129 350.79L115.315 312.434Z",
    fill: "#6A3FDC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M139.524 319.175L155.072 324.616L154.085 314.322",
    stroke: "#5321D7",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M142.037 272.959C142.037 272.959 145.165 291.162 149.739 294.905C151.241 296.134 154.084 293.007 167.172 292.745C175.175 292.585 175.168 320.518 164.549 319.718C153.929 318.917 137.791 312.296 135.372 291.936C133.252 274.074 142.037 272.959 142.037 272.959Z",
    fill: "#16005C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M155.072 298.29C155.072 298.29 157.771 303.316 163.091 299.912",
    stroke: "#C4C6C5",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M215.76 402.49H126.251V409.121C126.251 411.807 128.428 413.984 131.114 413.984H215.76C218.447 413.984 220.624 411.806 220.624 409.121V407.353C220.625 404.667 218.447 402.49 215.76 402.49Z",
    fill: "#1C145E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M288.456 336.008H184.334C181.239 336.008 178.626 338.309 178.234 341.378L169.846 407.057C169.377 410.733 172.24 413.985 175.945 413.985H280.068C283.163 413.985 285.775 411.685 286.168 408.616L294.556 342.936C295.025 339.261 292.162 336.008 288.456 336.008Z",
    fill: "#1C145E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M293.495 336.008H189.373C186.278 336.008 183.665 338.309 183.273 341.378L174.885 407.057C174.416 410.733 177.279 413.985 180.984 413.985H285.107C288.202 413.985 290.814 411.685 291.207 408.616L299.595 342.936C300.064 339.261 297.201 336.008 293.495 336.008Z",
    fill: "#6876EB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M243.94 382.054C248.276 377.939 248.789 371.44 245.085 367.536C241.381 363.633 234.864 363.804 230.528 367.918C226.192 372.033 225.679 378.532 229.383 382.436C233.087 386.339 239.604 386.168 243.94 382.054Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M291.225 413.429H161.619",
    stroke: "#1C145E",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M348.503 325.533L391.528 326.348L381.774 273.717L358.897 276.307C358.897 276.307 348.592 291.517 356.729 303.343C365.911 316.686 347.558 317.184 348.503 325.533Z",
    fill: "#16005C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M358.896 276.307C358.896 276.307 348.591 291.517 356.728 303.343C365.911 316.687 347.558 317.184 348.503 325.533",
    stroke: "#7079F1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M367.479 319.175C367.479 319.175 347.903 338.385 337.581 410.776H359.372L367.479 319.175Z",
    fill: "#7079F1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M419.216 313.824L410.697 410.776H347.406L355.285 373.747C355.285 373.747 331.189 361.176 367.479 319.175L376.498 314.536L415.685 311.577L419.216 313.824Z",
    fill: "#C3C8FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M367.479 362.566C367.479 362.566 363.685 369.064 367.333 374.281L361.961 410.776",
    stroke: "#7079F1",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M358.633 373.914L395.292 374.996",
    stroke: "#7079F1",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M402.519 392.164L398.642 345.532",
    stroke: "#7079F1",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M419.216 313.824C419.216 313.824 422.712 318.221 426.758 328.418C432.495 342.876 439.338 368.996 438.889 410.775H410.697L419.216 313.824Z",
    fill: "#C3C8FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M438.889 413.974C438.889 413.974 424.803 381.759 389.372 390.978C350.686 401.044 336.321 399.163 336.321 399.163L333.388 413.974H438.889Z",
    fill: "#E9A394"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M402.012 384.208L389.441 387.019L417.996 413.974H444.911C444.911 413.974 433.311 385.846 402.012 384.208Z",
    fill: "#7079F1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M402.789 392.568L408.777 390.739",
    stroke: "#C3C8FF",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M336.321 399.163L317.939 395.362L304.762 413.974H333.388L336.321 399.163Z",
    fill: "#E9A394"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M367.479 362.566L401.638 328.407L395.292 325.41L419.216 313.824L408.23 306.833H382.661L367.479 325.81L371.674 326.863L367.479 329.805V362.566Z",
    fill: "#7079F1"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M391.361 318.445L402.519 310.734L390.474 283.799L371.803 295.526L377.062 317.868L367.479 362.566L391.361 318.445Z",
    fill: "#E9A394"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M373.305 301.907L386.408 295.074L374.71 307.873L373.305 301.907Z",
    fill: "#E37A82"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M349.368 262.913L343.646 294.622H352.229L361.865 307.873L386.408 295.074L369.243 256.829L349.368 262.913Z",
    fill: "#E9A394"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M347.981 270.602L347.406 274.086L370.041 270.997L369.694 266.66L347.981 270.602Z",
    fill: "#E37A82"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M411.928 260.504C406.262 245.145 399.334 239.223 399.334 239.223C385.45 225.426 361.715 240.736 361.715 240.736C331.3 233.374 343.646 271.135 343.646 271.135L368.416 268.097C371.879 288.875 384.265 278.354 384.265 278.354L390.042 288.773C390.042 288.773 384.214 293.924 390.29 302.755C395.293 310.026 383.313 312.503 386.409 320.243L434.286 310.32C434.286 278.818 422.168 288.262 411.928 260.504Z",
    fill: "#16005C"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M341.705 271.379C341.705 271.379 337.325 249.819 345.371 242.804C349.567 239.145 362.78 240.736 362.78 240.736",
    stroke: "#7079F1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M437.42 309.412C437.42 309.412 441.244 295.074 420.411 278.817",
    stroke: "#16005C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M384.977 290.105C390.673 290.105 395.291 285.488 395.291 279.792C395.291 274.096 390.673 269.478 384.977 269.478C379.281 269.478 374.664 274.096 374.664 279.792C374.664 285.488 379.281 290.105 384.977 290.105Z",
    fill: "#E9A394"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M358.633 293.456L365.027 291.886C365.027 291.886 367.271 310.122 358.633 293.456Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M353.309 282.68C353.309 282.68 355.344 270.277 359.796 282.68",
    stroke: "#1C145E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M354.88 273.245C354.88 273.245 357.358 269.047 360.295 273.245H354.88Z",
    fill: "#16005C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M258.67 161.505C254.96 151.189 243.297 146.023 233.074 150.431C224.277 154.225 219.613 164.206 222.342 173.39C223.867 178.525 227.313 182.497 231.627 184.815C235.609 186.953 239.027 190.005 241.532 193.767L242.255 194.852L256.579 189.702L256.445 188.411C255.973 183.84 256.773 179.267 258.462 174.994C260.11 170.822 260.306 166.057 258.67 161.505Z",
    fill: "#C3C8FF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M258.67 161.505C254.96 151.189 243.297 146.023 233.074 150.431C224.277 154.225 219.613 164.206 222.342 173.39C223.867 178.525 227.313 182.497 231.627 184.815C235.609 186.953 239.027 190.005 241.532 193.767L242.255 194.852L256.579 189.702L256.445 188.411C255.973 183.84 256.773 179.267 258.462 174.994C260.11 170.822 260.306 166.057 258.67 161.505Z",
    fill: "#C3C8FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M245.532 190.627L234.114 174.524C234.114 174.524 234.322 171.264 237.906 171.781C241.489 172.298 243.629 177.954 241.072 177.041C238.514 176.129 237.609 169.48 242.449 168.466C247.287 167.453 248.905 178.446 246.231 176.328C243.557 174.21 244.121 167.211 249.303 167.153L252.343 190.378",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M256.246 200.709L249.52 203.127C246.962 204.047 244.143 202.719 243.224 200.162L241.802 196.207C240.882 193.65 242.21 190.83 244.767 189.911L251.494 187.492C254.051 186.572 256.87 187.901 257.79 190.458L259.212 194.413C260.131 196.97 258.803 199.789 256.246 200.709Z",
    fill: "#16005C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M257.83 183.912L237.573 191.194L241.128 201.083L261.385 193.8L257.83 183.912Z",
    fill: "#6876EB"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M240.192 143.973L238.171 132.386",
    stroke: "#C3C8FF",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M225.594 150.874L215.917 141.422",
    stroke: "#C3C8FF",
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M215.509 168.045L204.467 168.835",
    stroke: "#C3C8FF",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M256.108 150.322L261.077 141.106",
    stroke: "#C3C8FF",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M411.574 235.44H480.041C482.421 235.44 484.702 233.51 485.133 231.129L492.208 192.095C492.64 189.715 491.059 187.784 488.679 187.784H420.212C417.831 187.784 415.551 189.714 415.12 192.095L408.045 231.129C407.614 233.509 409.194 235.44 411.574 235.44Z",
    fill: "#1C145C"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M466.463 214.645C468.462 212.819 468.847 209.987 467.324 208.32C465.8 206.652 462.945 206.78 460.947 208.605C458.948 210.431 458.563 213.263 460.086 214.931C461.61 216.599 464.465 216.471 466.463 214.645Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M452.864 214.645C454.862 212.819 455.248 209.987 453.724 208.319C452.201 206.651 449.345 206.779 447.347 208.605C445.348 210.431 444.963 213.263 446.487 214.93C448.01 216.598 450.865 216.47 452.864 214.645Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M439.264 214.644C441.263 212.819 441.648 209.987 440.125 208.319C438.601 206.651 435.746 206.779 433.747 208.605C431.749 210.43 431.364 213.262 432.887 214.93C434.411 216.598 437.266 216.47 439.264 214.644Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M448.422 232.873L424.633 247.011L428.897 231.758L448.422 232.873Z",
    fill: "#1C145C"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M191.007 229.654H122.54C120.159 229.654 117.879 227.724 117.448 225.343L110.373 186.309C109.941 183.929 111.522 181.998 113.902 181.998H182.369C184.749 181.998 187.03 183.928 187.461 186.309L194.536 225.343C194.968 227.723 193.388 229.654 191.007 229.654Z",
    fill: "#C3C8FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M142.462 209.126C143.985 207.459 143.6 204.627 141.602 202.801C139.603 200.975 136.748 200.848 135.224 202.515C133.701 204.183 134.086 207.015 136.085 208.841C138.083 210.666 140.939 210.794 142.462 209.126Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M156.061 209.126C157.585 207.459 157.2 204.627 155.201 202.801C153.202 200.975 150.347 200.848 148.824 202.515C147.3 204.183 147.685 207.015 149.684 208.841C151.683 210.666 154.538 210.794 156.061 209.126Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M169.66 209.127C171.183 207.459 170.798 204.628 168.799 202.802C166.801 200.976 163.946 200.848 162.422 202.516C160.899 204.184 161.284 207.016 163.283 208.842C165.281 210.667 168.136 210.795 169.66 209.127Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M166.583 227.087L170.338 240.735L185.527 226.132L166.583 227.087Z",
    fill: "#C3C8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/Mission.1a1b1dcf43c5cdf7383f8f3ee17d7ce7.svg";
export { ForwardRef as ReactComponent };